// // ============================================================
// // src/components/FAQ.js
// // ============================================================
// import React, { useState } from "react";

// const faqs = [
//   { q: "What are your clinic timings?", a: "We are open Monday to Saturday from 9:00 AM to 8:00 PM, and Sundays from 9:00 AM to 5:00 PM. Emergency services are available 24/7 by calling our helpline." },
//   { q: "Is dental treatment painful?", a: "At PearlSmile, we use advanced pain management techniques including topical anaesthetics, buffered anaesthesia, and sedation options. The vast majority of our patients report zero to minimal discomfort during treatment." },
//   { q: "Do you accept dental insurance?", a: "Yes! We are empanelled with all major health insurance providers including Star Health, HDFC ERGO, ICICI Lombard, Bajaj Allianz, and more. Cashless treatment is available. We also offer EMI options for larger treatments." },
//   { q: "How long does a dental implant procedure take?", a: "The complete implant process typically takes 3–6 months, but only 2–3 actual appointments. The surgical placement takes about 60 minutes. Most patients can return to work the next day." },
//   { q: "Are your sterilisation standards up to international norms?", a: "Absolutely. We follow hospital-grade sterilisation protocols and hold ISO certification for infection control. All instruments are autoclaved and single-use items are never reused." },
//   { q: "Do you treat children? From what age?", a: "Yes! Our pediatric dental team works with children from infancy. We recommend the first visit by age 1 or when the first tooth appears. Our child-friendly rooms make visits fun for kids." },
// ];

// export default function FAQ() {
//   const [open, setOpen] = useState(null);
//   return (
//     <section className="faq" id="faq">
//       <div className="faq-inner">
//         <div className="faq-header">
//           <div className="section-tag">FAQ</div>
//           <h2 className="section-title">Frequently <em>Asked</em> Questions</h2>
//           <p className="section-desc" style={{ margin: "0 auto" }}>
//             Everything you need to know before your visit.
//           </p>
//         </div>
//         {faqs.map((f, i) => (
//           <div key={i} className={`faq-item${open === i ? " open" : ""}`}>
//             <div className="faq-q" onClick={() => setOpen(open === i ? null : i)}>
//               {f.q}
//               <div className="faq-toggle">+</div>
//             </div>
//             <div className="faq-a">{f.a}</div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

// ============================================================
// src/components/FAQ.js
// ✅ Specialty-aware FAQs — falls back to dental if type unknown
// ============================================================
import React, { useState } from "react";
import { useHospital } from "../context/HospitalContext";

const SPECIALTY_FAQS = {
  dental: [
    {
      q: "What are your clinic timings?",
      a: "We are open Monday to Saturday from 9:00 AM to 8:00 PM, and Sundays from 9:00 AM to 5:00 PM. Emergency services are available 24/7 by calling our helpline.",
    },
    {
      q: "Is dental treatment painful?",
      a: "We use advanced pain management techniques including topical anaesthetics, buffered anaesthesia, and sedation options. The vast majority of our patients report zero to minimal discomfort during treatment.",
    },
    {
      q: "Do you accept dental insurance?",
      a: "Yes! We are empanelled with all major health insurance providers including Star Health, HDFC ERGO, ICICI Lombard, Bajaj Allianz, and more. Cashless treatment is available. We also offer EMI options for larger treatments.",
    },
    {
      q: "How long does a dental implant procedure take?",
      a: "The complete implant process typically takes 3–6 months, but only 2–3 actual appointments. The surgical placement takes about 60 minutes. Most patients can return to work the next day.",
    },
    {
      q: "Are your sterilisation standards up to international norms?",
      a: "Absolutely. We follow hospital-grade sterilisation protocols and hold ISO certification for infection control. All instruments are autoclaved and single-use items are never reused.",
    },
    {
      q: "Do you treat children? From what age?",
      a: "Yes! Our pediatric dental team works with children from infancy. We recommend the first visit by age 1 or when the first tooth appears. Our child-friendly rooms make visits fun for kids.",
    },
  ],

  ayurved: [
    {
      q: "What are your centre timings?",
      a: "We are open Monday to Saturday from 7:00 AM to 8:00 PM, and Sundays from 8:00 AM to 2:00 PM for consultations and select therapies.",
    },
    {
      q: "What is Panchakarma and how long does it take?",
      a: "Panchakarma is a classical Ayurvedic detox program involving five purification therapies. A complete program typically spans 7–21 days depending on your constitution and health goals. Our Vaidyas design a personalised plan for each patient.",
    },
    {
      q: "Do I need a prior consultation before booking a therapy?",
      a: "Yes, a consultation with our Vaidya is required before any therapy to assess your Prakriti (body type), current imbalances, and design the right treatment plan for you.",
    },
    {
      q: "Are Ayurvedic treatments safe alongside modern medicines?",
      a: "In most cases, yes — but our Vaidyas will review your current medications during the consultation to ensure safe integration and avoid any interactions.",
    },
    {
      q: "Do you accept health insurance for Ayurvedic treatments?",
      a: "Select therapies are covered under certain CGHS and state health schemes. We also partner with a few private insurers. Our team will guide you through what's covered during your visit.",
    },
    {
      q: "What should I do to prepare for my first Panchakarma session?",
      a: "We recommend light meals the evening before, avoiding alcohol for at least 3 days prior, and wearing comfortable loose clothing. Our Vaidya will share a detailed pre-therapy guide after your consultation.",
    },
  ],

  ortho: [
    {
      q: "What are your OPD timings?",
      a: "Our Orthopedic OPD is open Monday to Saturday from 9:00 AM to 7:00 PM. Emergency orthopedic care is available 24/7 at our facility.",
    },
    {
      q: "When should I see an orthopedic surgeon vs a physiotherapist?",
      a: "If you have persistent pain for more than 4–6 weeks, sudden severe pain, joint swelling, or difficulty walking, a surgeon's evaluation is recommended. Physiotherapy is ideal for rehabilitation and milder musculoskeletal conditions.",
    },
    {
      q: "Is joint replacement surgery my only option for knee pain?",
      a: "Not necessarily. We always explore conservative options first — physiotherapy, injections, and bracing. Surgery is recommended only when conservative treatment fails to provide relief after adequate time.",
    },
    {
      q: "How long is recovery after a knee or hip replacement?",
      a: "Most patients walk within 24 hours of surgery with support. Return to daily activities takes 4–6 weeks, while full recovery and return to sport or heavy work can take 3–6 months.",
    },
    {
      q: "Do you offer minimally invasive joint surgery?",
      a: "Yes. We specialise in arthroscopic and minimally invasive techniques that result in smaller incisions, less pain, lower infection risk, and faster recovery compared to traditional open surgery.",
    },
    {
      q: "Does health insurance cover joint replacement surgery?",
      a: "Yes, most major health insurers cover joint replacement surgery. We are empanelled with all leading insurance providers and offer cashless treatment. Our billing team will assist with pre-authorisation.",
    },
  ],

  eye: [
    {
      q: "What are your OPD timings?",
      a: "Our Eye OPD is open Monday to Saturday from 9:00 AM to 7:00 PM. Emergency eye care is available around the clock.",
    },
    {
      q: "Am I eligible for LASIK surgery?",
      a: "LASIK eligibility depends on your corneal thickness, prescription stability, and eye health. The best way to know is a comprehensive pre-LASIK evaluation, which we offer free of charge.",
    },
    {
      q: "How long does cataract surgery take?",
      a: "The procedure itself takes approximately 10–15 minutes per eye. You can typically go home the same day. Most patients notice improved vision within 24 hours.",
    },
    {
      q: "Is LASIK painful? What is the recovery like?",
      a: "LASIK is virtually painless — you may feel mild pressure for about 30 seconds. Most patients resume normal activities within 24–48 hours, with full recovery in a week.",
    },
    {
      q: "At what age should children have their first eye check?",
      a: "We recommend a comprehensive eye check by age 3, before starting school. Early detection of conditions like lazy eye (amblyopia) or squint is critical for successful treatment.",
    },
    {
      q: "Does health insurance cover eye surgery?",
      a: "Cataract surgery is covered by most major health insurance plans. LASIK is typically not covered as it is considered elective. Our team will help you understand your insurance benefits.",
    },
  ],

  cardiology: [
    {
      q: "What are your cardiology OPD timings?",
      a: "Our Cardiac OPD is open Monday to Saturday from 9:00 AM to 6:00 PM. Our cardiac emergency unit operates 24/7.",
    },
    {
      q: "What symptoms should prompt an emergency cardiac visit?",
      a: "Chest pain or pressure, pain radiating to the left arm or jaw, sudden breathlessness, palpitations, fainting, or profuse sweating are all warning signs. Please call our emergency line or go to the nearest hospital immediately.",
    },
    {
      q: "What is the difference between angiography and angioplasty?",
      a: "Angiography is a diagnostic test that uses dye and X-rays to visualise blockages in the heart's arteries. Angioplasty is a treatment procedure where a balloon (and often a stent) is used to open those blockages.",
    },
    {
      q: "Is bypass surgery always necessary for a heart attack?",
      a: "Not always. Many heart attacks are treated with angioplasty and stenting. Bypass surgery (CABG) is recommended in specific cases such as severe multi-vessel disease or when angioplasty is not feasible.",
    },
    {
      q: "How often should I get a cardiac check-up?",
      a: "For adults over 40 with risk factors (diabetes, hypertension, family history, smoking), an annual cardiac evaluation is recommended. Otherwise, every 2–3 years is a good baseline.",
    },
    {
      q: "Does insurance cover cardiac procedures?",
      a: "Yes, most major health insurance plans cover cardiac procedures including angioplasty, bypass surgery, and pacemaker implantation. We offer cashless treatment with all leading insurers.",
    },
  ],

  pediatric: [
    {
      q: "What are your paediatric OPD timings?",
      a: "Our Children's OPD is open Monday to Saturday from 9:00 AM to 7:00 PM, and Sundays from 9:00 AM to 1:00 PM. Paediatric emergency care is available 24/7.",
    },
    {
      q: "From what age do you see patients?",
      a: "We care for patients from birth (newborn) through 18 years of age, including neonatology for premature and critically ill newborns.",
    },
    {
      q: "What vaccinations do you offer?",
      a: "We offer the full IAP (Indian Academy of Pediatrics) immunisation schedule as well as travel vaccines and optional vaccines like HPV, Varicella, and Hepatitis A. Our team will guide you through the schedule at each visit.",
    },
    {
      q: "My child has a fever — should I come to the emergency or OPD?",
      a: "If the fever is above 104°F (40°C), has lasted more than 3 days, or is accompanied by rash, stiff neck, difficulty breathing, or your child is very lethargic — come to emergency. For lower-grade fever in an otherwise alert child, OPD is appropriate.",
    },
    {
      q: "Do you have a separate waiting area for children?",
      a: "Yes! Our paediatric wing has a dedicated child-friendly waiting area with games, books, and activities to keep little ones comfortable and distracted before their appointment.",
    },
    {
      q: "Does health insurance cover paediatric consultations?",
      a: "Most family floater and individual health insurance policies cover paediatric consultations and hospitalisation. We are empanelled with all major insurers and offer cashless facilities.",
    },
  ],

  general: [
    {
      q: "What are your OPD timings?",
      a: "Our OPD operates Monday to Saturday from 8:00 AM to 8:00 PM. Emergency and casualty services are available 24 hours a day, 7 days a week.",
    },
    {
      q: "Do you offer second opinion consultations?",
      a: "Yes. Our senior specialists are available for second opinions on diagnoses, investigations, and treatment plans from other hospitals. You may bring all existing reports and scans.",
    },
    {
      q: "What specialties are available under one roof?",
      a: "We offer General Medicine, General Surgery, Orthopaedics, Cardiology, Neurology, Gynaecology, Paediatrics, ENT, Ophthalmology, Dermatology, and more — all at a single location.",
    },
    {
      q: "How do I get my reports and discharge summary?",
      a: "Reports are available within 24–48 hours online via our patient portal, or at the reports counter. Discharge summaries are provided on the day of discharge and also sent digitally.",
    },
    {
      q: "Are daycare procedures available?",
      a: "Yes, many surgical and diagnostic procedures are available as daycare (same-day discharge) — including minor surgeries, endoscopies, biopsies, chemotherapy, and dialysis sessions.",
    },
    {
      q: "Do you accept health insurance?",
      a: "We are empanelled with all major health insurance providers and TPA networks. Cashless treatment is available. Our insurance desk will assist you with documentation and pre-authorisation.",
    },
  ],
};

export default function FAQ() {
  const [open, setOpen] = useState(null);
  const { hospital } = useHospital();

  const type = (hospital?.type || "dental").toLowerCase();
  const faqs = SPECIALTY_FAQS[type] || SPECIALTY_FAQS.dental;

  return (
    <section className="faq" id="faq">
      <div className="faq-inner">
        <div className="faq-header">
          <div className="section-tag">FAQ</div>
          <h2 className="section-title">
            Frequently <em>Asked</em> Questions
          </h2>
          <p className="section-desc" style={{ margin: "0 auto" }}>
            Everything you need to know before your visit.
          </p>
        </div>
        {faqs.map((f, i) => (
          <div key={i} className={`faq-item${open === i ? " open" : ""}`}>
            <div
              className="faq-q"
              onClick={() => setOpen(open === i ? null : i)}
            >
              {f.q}
              <div className="faq-toggle">+</div>
            </div>
            <div className="faq-a">{f.a}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
